export default __webpack_public_path__ + "static/media/bathroom2-afterA-480w.f9036da2.webp";